angular.module("application")
	.constant('hostAddress', "https://backend.app.leonellospagnol.it");
